import React, { useEffect, useRef, useState } from "react";
// import './OurExclusivePartner.css'
import { Carousel } from "react-bootstrap";
import {
  Apiurl,
  Encryption,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../../Pages/utils/page";
import axios from "axios";
import "./OurExclusivePartner.css";
import OurExclusiveContactUsModal from "./OurExclusiveContactUsModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const OurExclusivePartner = ({
  handleShow,
  setLoading,
  setBannerIdData,
  bannerIdData,
  promotionalBanner
}) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const router = useNavigate();

  // Function to safely get and parse the cookie data

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [showPromoContactModal, setShowPromoContactModal] = useState(false);
  const [formData, setFormData] = useState({
    Username: "",
    UserEmail: "",
    PhoneNumber: "",
    Address: "",
    Query: "",
    BannerId: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    Username: "",
    UserEmail: "",
    PhoneNumber: "",
    Address: "",
    Query: "",
  });

 
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
    const selectedBanner = promotionalBanner?.FullBanners[selectedIndex];
    if (selectedBanner) {
      setBannerIdData(selectedBanner.Id);
    }
  };
  // Variables to track swipe start and end positions
  let touchStartX = 0;
  let touchEndX = 0;
  // Functions to handle touch events
  const handleTouchStart = (e) => {
    touchStartX = e.changedTouches[0].screenX;
  };
  const handleTouchEnd = (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipeGesture();
  };
  const handleSwipeGesture = () => {
    if (touchEndX < touchStartX) {
      // Swipe left, go to next slide
      const nextIndex =
        activeIndex + 1 < promotionalBanner.FullBanners?.length
          ? activeIndex + 1
          : 0;
      setActiveIndex(nextIndex);
      setBannerIdData(promotionalBanner?.FullBanners[nextIndex]?.Id);
    }
    if (touchEndX > touchStartX) {
      // Swipe right, go to previous slide
      const prevIndex =
        activeIndex - 1 >= 0 ? activeIndex - 1 : promotionalBanner.length - 1;
      setActiveIndex(prevIndex);
      setBannerIdData(promotionalBanner[prevIndex]?.Id);
    }
  };
  // get reward on banner view
  const getReward = () => {
    const data = {
      id: bannerIdData,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/AddNewPromotionalBannerImpression`,
    };
    axios(option)
      .then((e) => {})
      .catch((error) => {});
  };
  useEffect(() => {
    if (loginToken && bannerIdData) {
      getReward();
    }
  }, [loginToken, bannerIdData]);

  const handleCloseContactUsModal = () => {
    setShowPromoContactModal(false);
  };
  const Validations = () => {
    const errors = {};

    if (!formData?.Username || formData?.Username?.trim() === "") {
      errors.Username = "Name is required";
    }

    if (!formData?.UserEmail || formData?.UserEmail?.trim() === "") {
      errors.UserEmail = "Email is required";
    }
    if (!formData?.PhoneNumber) {
      errors.PhoneNumber = "Phone number is required";
    }
    if (!formData?.Address || formData?.Address?.trim() === "") {
      errors.Address = "Address is required";
    }
    if (!formData?.Query || formData?.Query?.trim() === "") {
      errors.Query = "Query is required";
    }

    // If there are errors, set them and return false
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      return false;
    }

    // If no errors, clear the error messages and return true
    setErrorMessage({
      Username: "",
      UserEmail: "",
      PhoneNumber: "",
      Address: "",
      Query: "",
    });
    return true;
  };
  const handleContactUs = () => {
    if (!Validations()) return;
    const data = {
      Username: formData?.Username,
      UserEmail: formData?.UserEmail,
      PhoneNumber: formData?.PhoneNumber,
      Address: formData?.Address,
      Query: formData?.Query,
      BannerId: formData?.BannerId,
    };

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Customer/UserQueriesAgainstPromotionalBanners`,
    };
    axios(options)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          setFormData({
            Username: "",
            UserEmail: "",
            PhoneNumber: "",
            Address: "",
            Query: "",
            BannerId: "",
          });
          handleCloseContactUsModal();
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  return (
    <>
      {promotionalBanner?.FullBanners?.length ? (
        <>
          {/* <div className="main_exlusive">
            <div className="container ">
              <div className="row">
                <div className="col-lg-12 mb_commn_pd_0">
                  <div className="promotional_banner"> */}
          {/* <h4 className="common_heading">
                      Our Exclusive Benefactors
                    </h4> */}
          <Carousel
            // className="banner_crousel_head"
            className="banner_crousel_head home_banner_1"
            interval={null}
            onSelect={handleSelect}
            activeIndex={activeIndex}
            ref={carouselRef}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {promotionalBanner?.FullBanners?.map((item) => {
              const image = item?.BannerSrc?.split('"');
              const imageURL = `${Apiurl()}/${image?.[1]}`;

              return (
                item?.IsPublish && ( // Only show if item is published
                  <Carousel.Item
                    key={item.Id}
                    className="Bannner-Inner-container"
                  >
                    {/* <button
                      type="button"
                      className="common_btn btn-primary contact_banner_us"
                      onClick={() => {
                        if (!loginToken) {
                          handleShow();
                        } else {
                          setFormData({
                            ...formData,
                            BannerId: item?.Id,
                          });
                          setShowPromoContactModal(true);
                        }
                      }}
                    >
                      Contact Us
                    </button> */}
                    {/* <button
                      type="button"
                      className="common_btn btn-primary contact_banner_us"
                      onClick={() => {
                        router(
                          `/promotionalbannerdetail/${Encryption(item?.Id)}`
                        );
                      }}
                    >
                      View{" "}
                    </button> */}

                    <img
                      className="Banner-image"
                      src={imageURL}
                      layout="intrinsic"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/Images/banner-default.jpg";
                      }}
                    />
                  </Carousel.Item>
                )
              );
            })}
          </Carousel>

          {/* <Carousel  className='banner_crousel_head' interval={null}>
      {promotionalBanner?.map((item) => {
        const banner = item?.BannerUrl.split('"')
            const bannerUrl = `${Apiurl()}/${banner?.[1]}`
      
        return (
          <Carousel.Item key={item.Id} className="Bannner-Inner-container" >
            <img
              className="Banner-image"
              src={bannerUrl}
              alt={item.BusinessName}
              layout="intrinsic"
              width={1200} // You can set appropriate width
              height={500} // You can set appropriate height
            />
          </Carousel.Item>
        );
      })}
    </Carousel>   */}
          {/* </div>
                </div>
              </div>
            </div>
          </div> */}
        </>
      ) : null}
      <OurExclusiveContactUsModal
        showPromoContactModal={showPromoContactModal}
        handleCloseContactUsModal={handleCloseContactUsModal}
        formData={formData}
        setFormData={setFormData}
        setErrorMessage={setErrorMessage}
        errorMessage={errorMessage}
        handleContactUs={handleContactUs}
      />
    </>
  );
};

export default OurExclusivePartner;
